import { render, staticRenderFns } from "./supplierBSelfMag.vue?vue&type=template&id=6d90ea94&scoped=true&"
import script from "./supplierBSelfMag.vue?vue&type=script&lang=js&"
export * from "./supplierBSelfMag.vue?vue&type=script&lang=js&"
import style0 from "./supplierBSelfMag.vue?vue&type=style&index=0&id=6d90ea94&scoped=true&lang=css&"
import style1 from "./supplierBSelfMag.vue?vue&type=style&index=1&id=6d90ea94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d90ea94",
  null
  
)

export default component.exports